import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted, watch, computed } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, email } from "@vuelidate/validators";
  import store from "@/store";
  import { ContactEmail } from "@/types/ContactEmail";
  import LandingFooter from "@/components/landing/LandingFooter.vue";
  import router from "@/router";
  import BuildersLanding from "@/components/landing/BuildersLanding.vue";
  import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import { useRoute } from "vue-router";
  import "@splidejs/vue-splide/dist/css/splide-core.min.css";
  import LandingSection from "@/components/landing/LandingSection.vue";
  import { landingSectionsData } from "@/constants/landingData";
  import LandingMobileHeader from "@/components/landing/LandingMobileHeader.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import ContactUsLink from "@/components/landing/ContactUsLink.vue";
  import { RouteLandingNames } from "@/enums/RouteLandingNames";
  import { headerTabs } from "@/constants/navigationTabs";
  import { SwitchItemHeader } from "@/types/SwitchItemHeader";

  const MIN_DESKTOP_WIDTH = 992;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Landing',
  setup(__props, { expose: __expose }) {
  __expose();

  const route = useRoute();
  const activeHeaderTab = ref<SwitchItemHeader | null>(null);
  const { isDesktop } = useIsDesktop(MIN_DESKTOP_WIDTH);

  const form = reactive<ContactEmail>({
    fullName: "",
    company: "",
    message: "",
    email: "",
    phone: "",
  });

  const rules = {
    fullName: { required, $autoDirty: true },
    company: { required, $autoDirty: true },
    email: { required, email, $autoDirty: true },
    phone: { required, $autoDirty: true },
  };
  const v$ = useVuelidate(rules, form, { $scope: false });

  const visibleHeaderTabs = computed(() =>
    headerTabs.filter((tab) => !tab.hidden)
  );

  watch(
    route,
    (value) => {
      if (value.name === RouteLandingNames.LANDING_BUILDERS) {
        activeHeaderTab.value = headerTabs[1];
      } else {
        activeHeaderTab.value = headerTabs[0];
      }
    },
    {
      immediate: true,
    }
  );

  onMounted(() => {
    if (
      router.currentRoute.value.name === RouteLandingNames.LANDING &&
      router.currentRoute.value.params.unauthorized
    ) {
      router.push({ name: "SignIn" });
    }
  });

  async function submitForm() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    store.dispatch("user/contactEmail", form).then(() => {
      Object.keys(form).forEach((index) => {
        form[index] = "";
      });
      v$.value.$reset();
    });
  }

  function onLogin() {
    router.push({ name: "SignIn" });
  }

  function onChangeHeaderTab(value: SwitchItemHeader) {
    router.push(value.path);
  }
  const goToBuildersLanding = () => {
    router.push({ name: RouteLandingNames.LANDING_BUILDERS });
  };

const __returned__ = { route, activeHeaderTab, MIN_DESKTOP_WIDTH, isDesktop, form, rules, v$, visibleHeaderTabs, submitForm, onLogin, onChangeHeaderTab, goToBuildersLanding, ref, reactive, onMounted, watch, computed, get useVuelidate() { return useVuelidate }, get required() { return required }, get email() { return email }, get store() { return store }, get ContactEmail() { return ContactEmail }, LandingFooter, get router() { return router }, BuildersLanding, SwitchComponent, get useRoute() { return useRoute }, LandingSection, get landingSectionsData() { return landingSectionsData }, LandingMobileHeader, get useIsDesktop() { return useIsDesktop }, ContactUsLink, get RouteLandingNames() { return RouteLandingNames }, get headerTabs() { return headerTabs }, get SwitchItemHeader() { return SwitchItemHeader } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})